'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.watchRemoteCreate = watchRemoteCreate;
exports.watchRemoteCreateSuccess = watchRemoteCreateSuccess;
exports.watchRemoteUpdate = watchRemoteUpdate;
exports.watchRemoteUpdateSuccess = watchRemoteUpdateSuccess;
exports.watchSubscribe = watchSubscribe;
exports.watchAdd = watchAdd;
exports.watchSet = watchSet;
exports.watchUpdateWorker = watchUpdateWorker;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _socket = require('../actions/socket');

var socketActions = _interopRequireWildcard(_socket);

var _messages = require('../actions/messages');

var messagesActions = _interopRequireWildcard(_messages);

var _discussions = require('../actions/discussions');

var discussionsActions = _interopRequireWildcard(_discussions);

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = [subscribe, callCreateWorker, publishCreationWorker, callUpdateWorker, publishUpdateWorker, subscribeWorker, subscribeAllWorker, updateWorker, checkDiscussionsOpenedWorker, watchRemoteCreate, watchRemoteCreateSuccess, watchRemoteUpdate, watchRemoteUpdateSuccess, watchSubscribe, watchAdd, watchSet, watchUpdateWorker].map(regeneratorRuntime.mark);

/**
 *	Subscribes to events from the discussion having the given id.
 */
function subscribe(chatId, id) {
	var actionCreator;
	return regeneratorRuntime.wrap(function subscribe$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					actionCreator = function actionCreator(type, data) {
						switch (type) {
							case 'update':
								return discussionsActions.update(chatId, data);

							case 'messages/create':
								return messagesActions.add(id, data);

							default:
								return null;
						}
					};

					_context.next = 3;
					return (0, _effects.put)(socketActions.subscribe('pubsub/discussions/' + id, actionCreator));

				case 3:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked[0], this);
}

/**
 *
 */
function callCreateWorker(_ref) {
	var payload = _ref.payload;
	var chatId = _ref.meta.chatId;
	var actionCreator;
	return regeneratorRuntime.wrap(function callCreateWorker$(_context2) {
		while (1) {
			switch (_context2.prev = _context2.next) {
				case 0:
					actionCreator = function actionCreator(discussion) {
						return discussionsActions.remoteCreateSuccess(chatId, discussion);
					};

					_context2.next = 3;
					return (0, _effects.put)(socketActions.call('rpc/chats/' + chatId + '/discussions/create', actionCreator, payload));

				case 3:
				case 'end':
					return _context2.stop();
			}
		}
	}, _marked[1], this);
}

/**
 *
 */
function publishCreationWorker(_ref2) {
	var discussion = _ref2.payload.discussion;
	var chatId = _ref2.meta.chatId;
	return regeneratorRuntime.wrap(function publishCreationWorker$(_context3) {
		while (1) {
			switch (_context3.prev = _context3.next) {
				case 0:
					_context3.next = 2;
					return (0, _effects.put)(socketActions.publish('pubsub/chats/' + chatId, 'discussions/create', discussion));

				case 2:
				case 'end':
					return _context3.stop();
			}
		}
	}, _marked[2], this);
}

/**
 *
 */
function callUpdateWorker(_ref3) {
	var fields = _ref3.payload.fields;
	var _ref3$meta = _ref3.meta;
	var chatId = _ref3$meta.chatId;
	var id = _ref3$meta.id;
	var actionCreator, data;
	return regeneratorRuntime.wrap(function callUpdateWorker$(_context4) {
		while (1) {
			switch (_context4.prev = _context4.next) {
				case 0:
					actionCreator = function actionCreator(discussion) {
						return discussionsActions.remoteUpdateSuccess(chatId, discussion);
					};

					data = _extends({}, fields, {
						id: id
					});
					_context4.next = 4;
					return (0, _effects.put)(socketActions.call('rpc/chats/' + chatId + '/discussions/update', actionCreator, data));

				case 4:
				case 'end':
					return _context4.stop();
			}
		}
	}, _marked[3], this);
}

/**
 *
 */
function publishUpdateWorker(_ref4) {
	var discussion = _ref4.payload.discussion;
	return regeneratorRuntime.wrap(function publishUpdateWorker$(_context5) {
		while (1) {
			switch (_context5.prev = _context5.next) {
				case 0:
					_context5.next = 2;
					return (0, _effects.put)(socketActions.publish('pubsub/discussions/' + discussion.id, 'update', discussion));

				case 2:
				case 'end':
					return _context5.stop();
			}
		}
	}, _marked[4], this);
}

/**
 * @see subscribe()
 */
function subscribeWorker(_ref5) {
	var _ref5$payload = _ref5.payload;
	var chatId = _ref5$payload.chatId;
	var id = _ref5$payload.id;
	return regeneratorRuntime.wrap(function subscribeWorker$(_context6) {
		while (1) {
			switch (_context6.prev = _context6.next) {
				case 0:
					_context6.next = 2;
					return subscribe(chatId, id);

				case 2:
				case 'end':
					return _context6.stop();
			}
		}
	}, _marked[5], this);
}

/**
 *	@see subscribe()
 */
function subscribeAllWorker(_ref6) {
	var discussions = _ref6.payload.discussions;
	var chatId = _ref6.meta.chatId;
	return regeneratorRuntime.wrap(function subscribeAllWorker$(_context7) {
		while (1) {
			switch (_context7.prev = _context7.next) {
				case 0:
					_context7.next = 2;
					return discussions.map(function (_ref7) {
						var id = _ref7.id;
						return subscribe(chatId, id);
					});

				case 2:
				case 'end':
					return _context7.stop();
			}
		}
	}, _marked[6], this);
}

/**
 *
 */
function updateWorker(_ref8) {
	var discussion = _ref8.payload.discussion;
	return regeneratorRuntime.wrap(function updateWorker$(_context8) {
		while (1) {
			switch (_context8.prev = _context8.next) {
				case 0:
					_context8.next = 2;
					return (0, _effects.put)(messagesActions.loadMessages(discussion.id));

				case 2:
				case 'end':
					return _context8.stop();
			}
		}
	}, _marked[7], this);
}

/**
 *
 */
function checkDiscussionsOpenedWorker(_ref9) {
	var discussion = _ref9.payload.discussion;
	var chatId = _ref9.meta.chatId;
	var discussionExist;
	return regeneratorRuntime.wrap(function checkDiscussionsOpenedWorker$(_context9) {
		while (1) {
			switch (_context9.prev = _context9.next) {
				case 0:
					_context9.next = 2;
					return (0, _effects.select)((0, _lodash.property)(['vtChat', 'discussions', chatId, discussion.id]));

				case 2:
					discussionExist = _context9.sent;
					_context9.next = 5;
					return (0, _effects.put)(discussionsActions.add(chatId, discussion));

				case 5:
					if (discussionExist) {
						_context9.next = 8;
						break;
					}

					_context9.next = 8;
					return (0, _effects.put)(discussionsActions.subscribe(chatId, discussion.id));

				case 8:
				case 'end':
					return _context9.stop();
			}
		}
	}, _marked[8], this);
}

/**
 *
 */
function watchRemoteCreate() {
	return regeneratorRuntime.wrap(function watchRemoteCreate$(_context10) {
		while (1) {
			switch (_context10.prev = _context10.next) {
				case 0:
					_context10.next = 2;
					return (0, _reduxSaga.takeEvery)(discussionsActions.REMOTE_CREATE, callCreateWorker);

				case 2:
				case 'end':
					return _context10.stop();
			}
		}
	}, _marked[9], this);
}

/**
 *
 */
function watchRemoteCreateSuccess() {
	return regeneratorRuntime.wrap(function watchRemoteCreateSuccess$(_context11) {
		while (1) {
			switch (_context11.prev = _context11.next) {
				case 0:
					_context11.next = 2;
					return (0, _reduxSaga.takeEvery)(discussionsActions.REMOTE_CREATE_SUCCESS, publishCreationWorker);

				case 2:
				case 'end':
					return _context11.stop();
			}
		}
	}, _marked[10], this);
}

/**
 *
 */
function watchRemoteUpdate() {
	return regeneratorRuntime.wrap(function watchRemoteUpdate$(_context12) {
		while (1) {
			switch (_context12.prev = _context12.next) {
				case 0:
					_context12.next = 2;
					return (0, _reduxSaga.takeEvery)(discussionsActions.REMOTE_UPDATE, callUpdateWorker);

				case 2:
				case 'end':
					return _context12.stop();
			}
		}
	}, _marked[11], this);
}

/**
 *
 */
function watchRemoteUpdateSuccess() {
	return regeneratorRuntime.wrap(function watchRemoteUpdateSuccess$(_context13) {
		while (1) {
			switch (_context13.prev = _context13.next) {
				case 0:
					_context13.next = 2;
					return (0, _reduxSaga.takeEvery)(discussionsActions.REMOTE_UPDATE_SUCCESS, publishUpdateWorker);

				case 2:
				case 'end':
					return _context13.stop();
			}
		}
	}, _marked[12], this);
}

/**
 *
 */
function watchSubscribe() {
	return regeneratorRuntime.wrap(function watchSubscribe$(_context14) {
		while (1) {
			switch (_context14.prev = _context14.next) {
				case 0:
					_context14.next = 2;
					return (0, _reduxSaga.takeEvery)(discussionsActions.SUBSCRIBE, subscribeWorker);

				case 2:
				case 'end':
					return _context14.stop();
			}
		}
	}, _marked[13], this);
}

/**
 *
 */
function watchAdd() {
	return regeneratorRuntime.wrap(function watchAdd$(_context15) {
		while (1) {
			switch (_context15.prev = _context15.next) {
				case 0:
					_context15.next = 2;
					return (0, _reduxSaga.takeEvery)(discussionsActions.ADD_REQUEST, checkDiscussionsOpenedWorker);

				case 2:
				case 'end':
					return _context15.stop();
			}
		}
	}, _marked[14], this);
}

/**
 *
 */
function watchSet() {
	return regeneratorRuntime.wrap(function watchSet$(_context16) {
		while (1) {
			switch (_context16.prev = _context16.next) {
				case 0:
					_context16.next = 2;
					return (0, _reduxSaga.takeEvery)(discussionsActions.SET, subscribeAllWorker);

				case 2:
				case 'end':
					return _context16.stop();
			}
		}
	}, _marked[15], this);
}

/**
 *
 */
function watchUpdateWorker() {
	return regeneratorRuntime.wrap(function watchUpdateWorker$(_context17) {
		while (1) {
			switch (_context17.prev = _context17.next) {
				case 0:
					_context17.next = 2;
					return (0, _reduxSaga.takeEvery)(discussionsActions.UPDATE, updateWorker);

				case 2:
				case 'end':
					return _context17.stop();
			}
		}
	}, _marked[16], this);
}